export const orderFilteredArticles = function ($section, $items) {
	const $firstCol = $section.find('.blog-grid-articles__col:nth-child(1)');
	const $secondCol = $section.find('.blog-grid-articles__col:nth-child(2)');
	const $thirdCol = $section.find('.blog-grid-articles__col:nth-child(3)');
	const $oldItems = $section.find('.item');

	$oldItems.remove();

	let colCounter = 1;

	$items.each(function() {
		const $item = $(this);

		switch(colCounter) {
			case 2:
				$item.appendTo($secondCol);
				break;
			case 3:
				$item.appendTo($thirdCol);
				break;
			default:
				$item.appendTo($firstCol);
		}

		if (colCounter === 3) {
			colCounter = 1;
		} else {
			colCounter++
		}
	});
}

export const orderArticles = function ($elements, $items) {
	$elements.each(function() {
		const $section = $(this);
		const $firstCol = $section.find('.blog-grid-articles__col:nth-child(1)');
		const $secondCol = $section.find('.blog-grid-articles__col:nth-child(2)');
		const $thirdCol = $section.find('.blog-grid-articles__col:nth-child(3)');
		const $items = $(this).find('.item');
		let colCounter = 1;

		$section.find('img').on('load', function(){
			$(window).trigger('resize').trigger('scroll');
		});

		$items.each(function() {
			const $item = $(this);

			switch(colCounter) {
				case 2:
					$item.appendTo($secondCol);
					break;
				case 3:
					$item.appendTo($thirdCol);
					break;
				default:
					$item.appendTo($firstCol);
			}

			if (colCounter === 3) {
				colCounter = 1;
			} else {
				colCounter++
			}
		});
	});
}

export default function initBlogGridArticles() {
	orderArticles($('.blog-grid-articles'));
}
